export default "__VITE_ASSET__CqGppvGZ__"